/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Btn_Notinterested1Inputs */

const en_btn_notinterested1 = /** @type {(inputs: Btn_Notinterested1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not interested`)
};

/**
* | output |
* | --- |
* | "Not interested" |
*
* @param {Btn_Notinterested1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const btn_notinterested1 = /** @type {((inputs?: Btn_Notinterested1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Btn_Notinterested1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_btn_notinterested1(inputs)
});
export { btn_notinterested1 as "btn_notInterested" }